/* Clean Premium purchase guard. Selection and rendering remain owned by Enterprise. */
(() => {
  if (window.macinoCleanPurchaseGuard) return;
  window.macinoCleanPurchaseGuard = true;
  const states = new WeakMap();
  const pickerSelector = 'variant-picker[data-clean-product-picker]';
  const scopeFor = (element) => element.closest('.js-quickbuy') || element.closest('[data-clean-product-scope]');
  const purchaseButtons = (scope) => scope.querySelectorAll('.js-product-form [type="submit"], [data-clean-product-mobile-bar] [type="submit"]');
  function clearState(scope, state) {
    clearTimeout(state.timer);
    state.pending = false;
    scope.removeAttribute('aria-busy');
    scope.querySelectorAll('[data-clean-product-payment]').forEach((element) => { element.inert = false; });
  }
  function getPending(scope) {
    const state = scope && states.get(scope);
    if (!state?.pending) return null;
    const picker = scope.querySelector(pickerSelector);
    if (!picker || picker.dataset.url !== state.productUrl) {
      clearState(scope, state);
      return null;
    }
    return state;
  }
  document.addEventListener('change', (event) => {
    const picker = event.target.closest?.(pickerSelector);
    if (!picker || typeof picker.constructVariantUrl !== 'function') return;
    const scope = scopeFor(picker);
    if (!scope) return;
    const previous = states.get(scope);
    if (previous) clearTimeout(previous.timer);
    scope.querySelector('[data-clean-product-sync-error]')?.remove();
    const optionIds = picker.getSelectedOptionIds();
    const url = picker.constructVariantUrl(
      event.target.dataset.productUrl || event.detail?.productUrl,
      optionIds,
      event.target.dataset.variantId || event.detail?.variantId
    );
    const pageUrl = new URL(url);
    pageUrl.searchParams.delete('sections');
    const state = {
      pending: true,
      productUrl: picker.dataset.url,
      options: picker.getSelectedOptions(),
      requestUrl: url.toString(),
      pageUrl: pageUrl.toString()
    };
    states.set(scope, state);
    scope.setAttribute('aria-busy', 'true');
    purchaseButtons(scope).forEach((button) => { button.disabled = true; });
    scope.querySelectorAll('[data-clean-product-payment]').forEach((element) => { element.inert = true; });
    state.timer = setTimeout(() => {
      if (states.get(scope) !== state || !scope.isConnected || !getPending(scope)) return;
      window.theme?.fetchCache?.pending?.delete(state.requestUrl);
      window.theme?.fetchCache?.cache?.delete(state.requestUrl);
      const error = document.createElement('div');
      error.className = 'alert mb-4 bg-error-bg text-error-text';
      error.dataset.cleanProductSyncError = '';
      error.setAttribute('role', 'alert');
      error.append(document.createTextNode('La selezione non è stata aggiornata. '));
      const link = document.createElement('a');
      link.className = 'link';
      link.href = state.pageUrl;
      link.textContent = window.theme?.strings?.viewDetails || 'Visualizza dettagli';
      error.append(link);
      (scope.querySelector('.product-options') || picker).after(error);
      purchaseButtons(scope).forEach((button) => { button.disabled = true; });
    }, 12000);
  }, true);
  document.addEventListener('on:variant:change', (event) => {
    const picker = event.target.closest?.(pickerSelector);
    if (!picker) return;
    const scope = scopeFor(picker);
    const state = getPending(scope);
    if (!state) return;
    const variant = event.detail?.variant;
    if (variant && state.options.some((value, index) => value !== null && value !== variant.options[index])) return;
    if (!variant && state.options.some((value, index) => value !== event.detail.selectedOptions[index])) return;
    clearState(scope, state);
    scope.querySelectorAll('[data-clean-product-payment]').forEach((element) => { element.inert = !variant?.available; });
    scope.querySelector('[data-clean-product-sync-error]')?.remove();
    purchaseButtons(scope).forEach((button) => { button.disabled = !variant?.available; });
  });
  document.addEventListener('submit', (event) => {
    if (!event.target.matches?.('.js-product-form')) return;
    const scope = scopeFor(event.target);
    if (!getPending(scope)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);
  document.addEventListener('click', (event) => {
    if (!event.target.closest?.('[data-clean-product-payment]')) return;
    if (!getPending(scopeFor(event.target))) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);
})();
